import Button from '@atlaskit/button/standard-button';
import EmptyState from '@atlaskit/empty-state';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION } from '../../../../../../analytics/Events';
import promotionsEmptyView from '../../../../../../images/promotions-empty-view.svg';
const PromotionsEmptyView = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onPrimaryActionClick = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION
    });
    props.onApplyPromotionsBtnClick();
  };
  const primaryAction = /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onPrimaryActionClick
  }, "Apply promotion codes");
  const EmptyStateprops = {
    header: 'No promotions applied yet',
    description: "Got a promotion code from a Marketplace partner? Apply it here to get discounts on installed apps.",
    imageUrl: promotionsEmptyView,
    primaryAction
  };
  return /*#__PURE__*/React.createElement(EmptyState, EmptyStateprops);
};
export default PromotionsEmptyView;